import React, { useState } from 'react';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUsedFeatures } from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice';

const Onboarding: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [campaign, setCampaign] = useState<'sms' | 'mms'>('sms');

  const handleNextStep = (step: number, type: 'sms' | 'mms') => {
    setStep(step);
    setCampaign(type)
  };

  const handleStartCampaign = () => {
    dispatch(setUsedFeatures({ campaign: true }))
    setStep(1)
    navigate('/new-message')
  };

  return (
    <div>
      {step === 1 && <FirstStep onNext={handleNextStep} />}
      {step === 2 && <SecondStep campaign={campaign}  onStartCampaign={handleStartCampaign} />}
    </div>
  );
};

export default Onboarding;